import { NavLink } from "react-router-dom";
import {
  Home,
  FileText,
  Database,
  Store,
  TrendingUp,
  ClipboardList,
  Calendar,
  BookMarked,
  Building2,
  SlidersHorizontal,
} from "lucide-react";

const NAV_ITEMS = [
  { path: "/feed",      label: "Feed",      icon: Home },
  { path: "/companies", label: "Companies", icon: Building2 },
  { path: "/docs",       label: "Documents", icon: FileText },
  { path: "/database",  label: "Database",  icon: Database },
  { path: "/vendors",   label: "Vendors",   icon: Store },
  { path: "/insights",  label: "Insights",  icon: TrendingUp },
  { path: "/surveys",   label: "Surveys",   icon: ClipboardList },
  { path: "/events",    label: "Events",    icon: Calendar },
  { path: "/resources", label: "Resources", icon: BookMarked },
];

const Sidebar = () => (
  <aside className="w-14 md:w-52 flex-shrink-0">
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden sticky top-24">
      <div className="hidden md:block px-4 pt-4 pb-2">
        <p className="text-[11px] font-semibold uppercase tracking-widest text-gray-400">
          Navigation
        </p>
      </div>

      <nav className="px-2 pt-2 pb-2 md:pt-0">
        {NAV_ITEMS.map(({ path, label, icon: Icon }) => (
          <NavLink
            key={path}
            to={path}
            title={label}
            aria-label={label}
            className={({ isActive }) =>
              `flex items-center justify-center md:justify-start gap-3 px-2 md:px-3 py-2.5 rounded-xl text-[15px] transition-all duration-200 ${
                isActive
                  ? "bg-amber-50 text-amber-700 font-semibold"
                  : "text-gray-600 font-medium hover:bg-gray-50 hover:text-gray-900"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon
                  size={17}
                  className={`flex-shrink-0 ${isActive ? "text-amber-600" : "text-gray-400"}`}
                />
                <span className="hidden md:inline">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="mx-2 md:mx-4 border-t border-gray-100" />

      <div className="px-2 py-2">
        <NavLink
          to="/settings"
          title="Settings"
          aria-label="Settings"
          className={({ isActive }) =>
            `flex items-center justify-center md:justify-start gap-3 px-2 md:px-3 py-2.5 rounded-xl text-[15px] transition-all duration-200 ${
              isActive
                ? "bg-amber-50 text-amber-700 font-semibold"
                : "text-gray-600 font-medium hover:bg-gray-50 hover:text-gray-900"
            }`
          }
        >
          {({ isActive }) => (
            <>
              <SlidersHorizontal
                size={17}
                className={`flex-shrink-0 ${isActive ? "text-amber-600" : "text-gray-400"}`}
              />
              <span className="hidden md:inline">Settings</span>
            </>
          )}
        </NavLink>
      </div>
    </div>
  </aside>
);

export default Sidebar;
